<template>
  <div class="map_search_dropdown">
    <div v-if="isImport" class="imp_res">
      <span>
        导入结果&nbsp;成功&nbsp;<i>{{ impRes.successCount }}</i>，
        <span :class="{'fail_num':!importNbhd}" @click="onClickFail">失败&nbsp;{{ impRes.failCount }}</span>
        <template v-if="importNbhd">，缺货&nbsp;{{ impRes.shortageCount }}</template>
      </span>
      <div class="fr">
        <span class="line"></span>
        <span v-if="importNbhd" class="see_list" @click="showResult = true">查看小区</span>
        <span @click="cancelImport">取消导入</span>
      </div>
    </div>
    <poi-search v-else @selectPoi="onSelectPoi"></poi-search>
    <import-result-detail :visible.sync="showResult" :import-type="importType" :uuid="uuid"></import-result-detail>
    <failed-chain :visible.sync="showFail" :chains="impRes.failedItems" />
  </div>
</template>

<script>
import PoiSearch from './PoiSearch'
import ImportResultDetail from '@/views/PutOrder/dialog/ImportResult'
import FailedChain from './FailedChain'

export default {
  name: 'MapSearch',
  components: { PoiSearch, ImportResultDetail, FailedChain },
  data() {
    return {
      uuid: '',
      importType: '',
      isImport: false,
      showResult: false,
      showFail: false
    }
  },
  computed: {
    impRes() {
      return this.$store.state.bmap.exportPointData
    },
    importNbhd() {
      return this.$store.state.bmap.mapImportNbhdSearchList.length > 0
    }
  },
  watch: {
    impRes(data) {
      this.isImport = data.hasOwnProperty('successCount')
      this.uuid = data.uuid || ''
      this.importType = data.hasOwnProperty('pointList') ? 'device' : ''
    }
  },
  methods: {
    onClickFail() {
      if (!this.importNbhd && this.impRes.failCount > 0) {
        this.showFail = true
      }
    },
    cancelImport() {
      this.$store.commit('setExportPointData', {})
      this.$store.commit('setImportNbhdList', [])
      this.$store.commit('setImportPointList', [])
      this.$store.commit('setImportPointData', {})
      this.$emit('search')
    },
    onSelectPoi(p) {
      this.$root.$emit('searchChangePoint', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.map_search_dropdown {
  position: relative;
  display: inline-block;
  min-width: 320px;
  height: 36px;
  margin-left: 5px;
  vertical-align: top;

  .imp_res {
    height: 36px;
    line-height: 36px;
    background: #fff;
    box-shadow: 0px 2px 8px 0px rgba(40, 39, 41, 0.3);
    border-radius: 4px;
    padding: 0 20px;
    i {
      font-style: normal;
      color: #FF3973;
      margin-left: 2px;
    }
    .fail_num {
      cursor: pointer;
    }
    .fr {
      cursor: pointer;
      font-size: 12px;
      color: #282729;
      span {
        cursor: pointer;
        display: inline-block;
        line-height: 1.2;
        margin-right: 10px;
        &.see_list {
          color: #999;
        }
        &.line {
          width: 1px;
          height: 14px;
          border-left: 1px solid #e9e9e9;
          margin-left: 20px;
          margin-right: 20px;
          position: relative;
          top: 3px;
        }
      }
    }
  }
}
</style>
